export const massUpdatableFields = {
  Delivery: {
    'givenDispatchAddress': 'Dispatch Address',
    'products.givenCertifications': 'Product Certifications',
    'supplierName': 'Given Supplier Name',
    'givenSupplierCertifications': 'Given Supplier Certifications',
    'tradeContractor': 'Trade Contractor',
    'deliveryAddress': 'Delivery Address'
  },
  Waste: {
    'carrierName': 'Carrier Name',
    'items.containerType': 'Container Type',
    'facilityOperatorName': 'Facility Operator',
    'subcontractorName': 'Subcontractor',
    'originSiteAddress': 'Origin Site Address',
    'facilitySiteAddress': 'Facility Site Address',
    'items.wasteCode': 'Waste Code (EWC)'
  }
}
